import React, { useEffect, useState } from 'react';

const BackToTop: React.FC = () => {
  const [visible, setVisible] = useState(false);

  const toggleVisible = () => {
    const scrolled = document.documentElement.scrollTop;

    if (scrolled > 300) {
      setVisible(true);
    } else {
      setVisible(false);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  useEffect(() => {
    window.addEventListener('scroll', toggleVisible);
    return () => window.removeEventListener('scroll', toggleVisible);
  }, []);

  return (
    <React.Fragment>
      <div className="back-to-top" onClick={scrollToTop}>
        <i className="fas fa-arrow-up" />
      </div>
      {/* language=CSS */}
      <style jsx>{`
        .back-to-top {
          display: ${visible ? 'block' : 'none'};
          position: fixed;
          bottom: 8rem;
          right: 4rem;
          font-size: 14px;
          text-align: center;
          line-height: 32px;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          z-index: 999;
          background-color: #ffffff;
          border: 1px solid #ddd;
          color: #333;
          cursor: pointer;
          transition: all 0.2s ease-in-out;
        }
      `}</style>
    </React.Fragment>
  );
};

export default BackToTop;
